import { csx } from '@vtex/admin-ui'

export const styles = {
  section: csx({
    display: 'flex',
    flexDirection: 'column',
    gap: '$space-3',
  }),
  card: csx({
    background: '$primary',
    border: '$neutral',
    borderRadius: 8,
    padding: '$space-3',
  }),
  cardRow: csx({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '$space-4',
    width: '100%',
  }),
  leftCluster: csx({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '$space-3',
    flex: 1,
    minWidth: 0,
  }),
  iconBox: csx({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    padding: '0.625rem',
    background: '$gray10',
    color: '$secondary',
    borderRadius: 4,
  }),
  textColumn: csx({
    display: 'flex',
    flexDirection: 'column',
    gap: '$space-1',
    minWidth: 0,
  }),
  clickableRow: csx({
    cursor: 'pointer',
    borderRadius: 4,
    outline: 'none',
  }),
  notificationContent: csx({
    display: 'flex',
    flexDirection: 'column',
    gap: '$space-4',
    width: '100%',
  }),
  thresholdsContainer: csx({
    background: '$secondary',
    borderRadius: 4,
    padding: '$space-3 $space-4',
    marginTop: '$space-3',
    display: 'flex',
    flexDirection: 'column',
    gap: '$space-3',
    '[data-error="true"]': {
      border: '$critical',
    },
  }),
  thresholdsInput: csx({
    display: 'flex',
    flexDirection: 'column',
    gap: '$space-2',
    width: '100%',
  }),
  thresholdsList: csx({
    display: 'flex',
    justifyContent: 'space-between',
  }),
  thresholdItem: csx({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '$space-2',
    "> div": {
      // Compensate checkbox element style space
      marginRight: "-0.5rem",
    }
  }),
  checkbox: csx({
    background: 'white',
  }),
}
